module.exports = __webpack_public_path__ + "img/DE00223.fd97d647.png";